import { AlignCenter, FlexBetween, FlexCenter } from '../../global/commonStyle';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { Typography } from '../../global/theme';
import styled, { css } from 'styled-components';

export const DropDiv = styled.div`
  .active-dropdown {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
  }
  .project-embed-card-dropdown {
    border-radius: var(--border-radius-6);
  }
`;

export const BackArrowIcon = styled.div`
  ${FlexCenter}
  opacity: 0;
  visibility: hidden;
  transition: opacity var(--transition-fast) ease-in-out;
`;

export const ProjectLinkEmbedContainer = styled.div`
  ${FlexBetween}
  max-width: 300px;
  min-width: 300px;
  padding: var(--space-8) var(--space-10);
  gap: var(--space-8);
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--border-primary);
  background: var(--background-tertiary);
  margin-top: var(--space-12);
  position: relative;
  cursor: pointer;
  ${mobile_xl(
    css`
      min-width: unset;
      align-items: flex-start;
    `
  )}

  &:hover {
    ${BackArrowIcon} {
      opacity: 1;
      visibility: visible;
      cursor: pointer;
    }
  }
`;

export const ProjectContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

export const ProjectName = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;

export const ProjectProgress = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

export const ProjectStatusDot = styled.span<{ $statusColor: string }>`
  width: 8px;
  height: 8px;
  border-radius: var(--border-radius-full);
  background: ${(props) => props.$statusColor || 'var(--neutral-primary)'};
`;

export const ProjectStatusText = styled.span`
  ${Typography.body_sm}
  color: var(--text-secondary);
`;
